import { useMutation, useQueryClient } from 'react-query';
import { authFetch } from '../../../CommonUtils/authFetch';
import { httpBodyOptions } from '../../../CommonUtils/httpBodyOptions';
import { queryKeys } from './queryKeys';

interface FetcherParams {
  clientId: string;
  id: string;
}

const deleteAccount = ({ clientId, id }: FetcherParams) => {
  return authFetch('/Consumer/AccountUpdate/DeleteAccount', {
    method: 'POST',
    ...httpBodyOptions({ clientId, AccountId: id }),
  });
};

interface Params {
  clientId: string;
}

export const useDeleteAccountMutation = ({ clientId }: Params) => {
  const queryClient = useQueryClient();

  return useMutation(deleteAccount, {
    async onSuccess() {
      await queryClient.refetchQueries(queryKeys.stockOptions(clientId));
    },
  });
};
